import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableCellHead,
  TableHead,
  TableRow,
} from '~/ui/Table';
import styles from './EventsTable.module.scss';
import EventType from './EventType/EventType';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { IUserRoles } from '~/pages/Events/Events';
import { getPaginate } from '~/utils/getPaginate';
import { paginateEnums } from '~/utils/types/paginateEnums';

interface IEventProps {
  id: number;
  created_at: string;
  user_id: number;
  type: { display_name: string; id: number };
  user: {
    code: number;
    user_role: { id: number; name: string; text: string }[];
    role_id: number;
  };
  event: string;
  event_name: string;
}

interface IEventsTableProps {
  events: IEventProps[];
  sort: any;
  setSort: ({ field, direction }: any) => void;
  userRoles: IUserRoles[] | undefined;
}

const EventsTable = ({
  events,
  sort,
  setSort,
  userRoles,
}: IEventsTableProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { value, paginate } = getPaginate(paginateEnums.EVENT_PAGINATE)

  return (
    <Table>
      <TableHead sort={sort} setSort={setSort}>
        <TableCellHead field="type_id">{t('event')}</TableCellHead>
        <TableCellHead field="user_id">{t('initiator')}</TableCellHead>
        <TableCellHead field="role_id" sortable={false}>
          {t('user_role')}
        </TableCellHead>
        <TableCellHead field="created_at">{t('event_date')}</TableCellHead>
        <TableCellHead field="event">{t('event_type')}</TableCellHead>
      </TableHead>
      <TableBody>
        {events?.map(event => {
          const role = userRoles?.find(
            item => item.id === event?.user?.role_id
          );
          return (
            <TableRow
              key={event?.id}
              onClick={() => {
                if (event.user_id) {
                  navigate(
                    `/user/${event.user_id}/events?date=${dayjs(
                      event.created_at
                    ).format('DD.MM.YYYY')}&${value}=${paginate}`
                  );
                } else {
                  return;
                }
              }}
              style={styles.row}
            >
              <TableCell>{event?.type?.display_name}</TableCell>
              <TableCell className={styles.nameCell}>
                {event?.user?.code || '-'}
              </TableCell>
              <TableCell className={styles.nameCell}>
                {role?.display_name || '-'}
              </TableCell>
              <TableCell>
                {dayjs(event?.created_at).format('DD.MM.YYYY HH:mm:ss')}
              </TableCell>
              <TableCell className={styles.typeCell}>
                <EventType
                  eventType={event?.event}
                  eventName={event?.event_name}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default EventsTable;
